var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-settings"},[_c('general-settings',{attrs:{"subscription":_vm.subscription}}),_c('extension-settings',{attrs:{"subscription":_vm.subscription,"saving":!!_vm.savingSubSettings},on:{"flag-change":_vm.handleUpdateSubscriptionFlag,"update-extension-attributes":_vm.handleUpdateExtensionAttributes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }